import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';

import PropTypes from 'prop-types';

import BasicButton from '../buttons/basicButton';

export default function AlertDialog3Options({ button1Text, button2Text, button3Text, handleOption1, handleOption2, handleOption3, message, open, title }) {
  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>{message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <BasicButton handleClick={handleOption1} text={button1Text} type='accept' />
          <BasicButton handleClick={handleOption2} text={button2Text} type='warn' />
          <BasicButton handleClick={handleOption3} text={button3Text} type='cancel' />
        </DialogActions>
      </Dialog>
    </div>
  );
}

// Indica i controla els props que se han de passar al component
AlertDialog3Options.propTypes = {
  button1Text: PropTypes.string,
  button2Text: PropTypes.string,
  button3Text: PropTypes.string,
  handleOption1: PropTypes.func.isRequired,
  handleOption2: PropTypes.func.isRequired,
  handleOption3: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};
